'use client';
import Filters from '@c/filters/Filters';
import MasterProductHeader from '@c/headers/MasterProductHeader';
import PageMainContent from '@c/products/PageMainContent';
import { useCategoryFilters } from '@util/hooks/useCategoryFilters';
import useProductsPage, {
  PageSideFilters,
  TopFilters,
} from '@util/hooks/useProductsPage';
import { Pagination } from '@util/types/paginator';
import { DataDepot } from 'app/data-depot/_components/DataDepotForm';
import SearchControls from 'app/search/components/SearchControls';
import { FacetCounts, ProductLight } from 'models/product';

export default function MasterProductPage(props: {
  initialProducts: ProductLight[];
  initialPageInfo: Pagination;
  initialTopFilters: TopFilters;
  initialSideFilters: PageSideFilters;
  keyword: string;
  // allBrands: string[];
  facet_counts?: FacetCounts;
  // categories: CategoryDocument[];
  masterProduct: DataDepot;
  mpn: string;
  fitment: Map<string, Map<string, { years: number[]; rideType: string }>>;
}) {
  const {
    buttonToggles,
    sideFilters,
    handleSideFiltersChange,
    handleSortChange,
    handleSearchChange,
    setDrawerOpen,
    isFetching,
    setIsFetching,
    handleReset,
  } = useProductsPage({
    current_cat: null,
    keyword: props.keyword,
    category: null,
    category1: null,
    category2: null,
    category3: null,
    results: props.initialProducts,
    pageInfo: props.initialPageInfo,
    initialSideFilters: props.initialSideFilters,
    initialTopFilters: props.initialTopFilters,
    color: props.initialSideFilters.color,
    categories: [],
    is_featured: false,
    on_sale: false,
    is_auction: false,
    curated_list: null,
    seller_id: null,
    brands: [],
    // brands: props.allBrands,
    facet_counts: props.facet_counts,
  });

  const {
    handleFilterChange,
    handleCategoryChange,
    handleBikeSelection,
    handleSizeChange,
    handlePriceRangeChange,
    activePage,
    setActivePage,
    pendingFilterChanges,
    setPendingFilterChanges,
  } = useCategoryFilters({
    filterState: sideFilters,
    setFilterState: handleSideFiltersChange,
  });

  return (
    <div className="mx-auto max-w-[150rem]">
      <MasterProductHeader
        product={props.masterProduct}
        mpn={props.mpn}
        fitment={props.fitment}
      />
      <PageMainContent
        view={props.initialTopFilters.view}
        isFetching={isFetching}
        clearAllFilters={handleReset}
        setIsFetching={setIsFetching}
        products={props.initialProducts}
        pageInfo={props.initialPageInfo}
        filterState={props.initialSideFilters}
        attribution={{
          data_source: 'typesense',
          page: 'master-product',
          section: `products-${props.initialTopFilters.view}`,
        }}
        onFiltersChange={handleSideFiltersChange}
        filters={
          <div className="w-[30rem]">
            <Filters
              categories={[]}
              facet_counts={props.facet_counts}
              filterState={props.initialSideFilters}
              handleFilterChange={handleFilterChange}
              handleCategoryChange={handleCategoryChange}
              handleBikeSelection={handleBikeSelection}
              handleSizeChange={handleSizeChange}
              handlePriceRangeChange={handlePriceRangeChange}
              activePage={activePage}
              setActivePage={setActivePage}
              pendingFilterChanges={pendingFilterChanges}
              setPendingFilterChanges={setPendingFilterChanges}
            />
          </div>
        }
        controls={
          <SearchControls
            showSearch={false}
            buttonToggles={buttonToggles}
            currentCat={null}
            dropdownOpen={false}
            facet_counts={props.facet_counts}
            filterState={props.initialSideFilters}
            handleConditionsChange={(value) =>
              handleFilterChange('conditions', value)
            }
            handleSaleChange={(value) => handleFilterChange('onsale', value)}
            handleSearchChange={handleSearchChange}
            handleSellerTypeChange={(value) =>
              handleFilterChange('sellerType', value)
            }
            handleSortChange={handleSortChange}
            keyword={props.keyword ?? ''}
            pageType={'master-product'}
            setDrawerOpen={setDrawerOpen}
            setDropdownOpen={() => {}}
            setFilterState={handleSideFiltersChange}
            topFilters={props.initialTopFilters}
            categories={[]}
          />
        }
        hidePaginator={false}
      />
    </div>
  );
}
